require.config({
    deps: (typeof window !== 'undefined' && window.mocha) ?
        ['../test/spec/initialize'] :
        (
            (typeof window !== 'undefined' && window.Benchmark) ?
            ['../test/benchmark/initialize'] :
            ['initialize']
        ),
    baseUrl: (typeof window !== 'undefined' && (window.mocha || window.Benchmark)) ? '../../app/' : 'app/',
    paths: {
        backbone: '../bower_components/backbone/backbone',
        chaplin: '../bower_components/chaplin/chaplin',
        // localstorage: 'backbone.localStorage/backbone.localStorage.js',
        // sinon: 'sinonjs/sinon',
        // expect: 'expect/expect',
        i18n: '../bower_components/i18next/release/i18next.amd-1.7.1.min',
        // jquery: '../bower_components/jquery/jquery',
        bootstrap: '../bower_components/bootstrap/dist/js/bootstrap.min',
        underscore: '../bower_components/lodash/dist/lodash.compat',
        // nprogress: '../assets/scripts/nprogress/nprogress',
        datepicker: '../assets/scripts/bootstrap-datepicker',

        'datatables.net': '../bower_components/datatables/media/js/jquery.dataTables',
        dtBootstrap: '../bower_components/datatables/media/js/dataTables.bootstrap',
        dtScroller: '../bower_components/datatables-scroller/js/dataTables.scroller',

        // select2: 'select2/dist/js/select2',
        text: '../bower_components/requirejs-text/text',
        json: '../bower_components/requirejs-plugins/src/json',
        ejs: '../bower_components/ejs/ejs',
        has: '../bower_components/has/has',
        bcsocket: '../assets/scripts/bcsocket',
        jscrollbar: '../bower_components/jquery.scrollbar/jquery.scrollbar',

        moment: '../bower_components/moment/min/moment-with-locales'
    },
    shim: {
        underscore: {
            exports: '_'
        },
        backbone: {
            deps: ['underscore', 'bootstrap'],
            exports: 'Backbone'
        },
        bootstrap: {
            // deps: ['jquery']
        },
        datepicker: {
            deps: ['bootstrap']
        },
        // select2: {
        //     deps: ['bootstrap']
        // },
        // nprogress: {
            // deps: ['jquery']
        // },
        // 'datatables.net': {
        // },
        // dtBootstrap: {
        //     deps: ['datatables.net', 'bootstrap']
        // },
        // dtScroller: {
        //     deps: ['datatables.net']
        // },
        // expect: {
        //     exports: 'expect'
        // },
        // sinon: {
        //     exports: 'sinon'
        // },
        ejs: {
            exports: 'ejs'
        },
        bcsocket: {
            exports: 'BCSocket'
        }
    }
});
define("main", function(){});

